import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'common/data-entry/Select';

import { initializeProcessor, setValueProcessor } from 'components/eui/EuiFiltersContext/processors';
import { FRS_READY, FRS_UNINITIALIZED } from 'components/eui/EuiFiltersContext/reducer';
import { SelectedStudyPCN } from 'components/pages/setup/Protocol/ProtocolDetailsStudySelector/SelectedStudyPCN/SelectedStudyPCN';

import useFilterSyncCache from '../../hooks/useFilterSyncCache';

import './StudyPcn.scss';

export default function StudyPcn({ uniqKey, state, dispatch, getStudies = defaultGetOptions }) {
  const { t } = useTranslation();
  const fState = state[uniqKey];
  const fStatus = state.schema[uniqKey].status;

  useEffect(
    function() {
      if (fStatus === FRS_UNINITIALIZED) {
        getStudies().then(function(payload) {
          dispatch({
            type: 'PERFORM',
            processor: initializeProcessor,
            payload: {
              key: uniqKey,
              ...payload
            }
          });
        });
      }
    },
    [uniqKey, dispatch, fStatus, getStudies]
  );

  useFilterSyncCache({ uniqKey });

  if (fStatus !== FRS_READY) return null;

  const { source, value } = fState;

  return (
    <>
      <Select
        className="eui-filter-control-study-pcn"
        dataSource={source}
        value={value}
        onChange={selectedOption => {
          dispatch({
            type: 'PERFORM',
            processor: setValueProcessor,
            payload: {
              key: uniqKey,
              value: selectedOption
            }
          });
        }}
        label={t('study')}
        searchable={true}
        closeOnSelectedOptionClick={false}
        deselectOnSelectedOptionClick={false}
        clearable={false}
        validate={false}
        customFilterFunction={function(e, index, collection, searchString) {
          return `${e.pcn} ${e.name}`.toLowerCase().includes(searchString);
        }}
        customOptionTemplateFunction={function(e) {
          return (
            <>
              <div className="eui-filter-control-study-pcn-label">{e?.pcn}</div>
              <div>{e?.name}</div>
            </>
          );
        }}
        customSelectedValueTemplateFunction={function([selectedValue]) {
          if (!selectedValue) {
            return null;
          }
          return <SelectedStudyPCN studyName={selectedValue?.name} pcn={selectedValue?.pcn} />;
        }}
      />
    </>
  );
}

function defaultGetOptions() {
  return Promise.resolve();
}
